export enum SeverityEnum {
  Success = 'success',
  Info = 'info',
  Warn = 'warn',
  Error = 'error',
}
